import React, { useCallback } from 'react';

import DatePanel from './DatePanel';
import { DatePickerValueType } from './DatePicker.types';

export interface ICalendarProps {
  value?: DatePickerValueType;
  onChange?: (date: Date) => void;
  disabledDate?: (date: Date) => boolean;
  dateOptions?: Date[];
  preDateOptions?: Date[];
  className?: string;
}

const Calendar: React.FC<ICalendarProps> = ({
  value,
  onChange,
  disabledDate,
  dateOptions,
  preDateOptions,
  className = ''
}) => {
  const handleChange = useCallback(
    (date: Date) => {
      onChange?.(date);
    },
    [onChange]
  );

  return (
    <div className={className}>
      <DatePanel
        value={value}
        onChange={handleChange}
        disabledDate={disabledDate}
        dateOptions={dateOptions}
        preDateOptions={preDateOptions}
      />
    </div>
  );
};

export default Calendar;
